module.exports = __webpack_public_path__ + "static/media/Life-100-With-Insulin-And-Jamie.d1a1c71e.pdf";